import { render, staticRenderFns } from "./AddSettings.vue?vue&type=template&id=2d1adb66"
import script from "./AddSettings.vue?vue&type=script&lang=js"
export * from "./AddSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports